export enum LoginStage {
  InputCredentials,
  AcceptLicenseAgreement,
  Onboarding,
  MustResetPassword,
  Select2FA,
  Input2FA,
}
